import { render, staticRenderFns } from "./IconBank.vue?vue&type=template&id=5281f986&"
import script from "./IconBank.vue?vue&type=script&lang=js&"
export * from "./IconBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports